module.exports = __webpack_public_path__ + "1_placa_compra_inteligente.png?c72db37745487b45dcf442bf6665fab7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/1_placa_compra_inteligente.png
// module id = 114
// module chunks = 0